import { $api } from "../../../../services/request.config";
import { clearAttachmentsAllowedAction, isAttachmentsAllowedAction } from "../isAttachmentsAllowed.action";

export const isAttachmentsAllowedThunkAction = ({requestTypeId}) => async (dispatch) => {
    try {

        const response = await $api(`v1/requests/types/${requestTypeId}/attachments-allowed`);
        if (response.status === 200) {
        console.log("OPTION: ",response.data);
            dispatch(isAttachmentsAllowedAction(response.data.isUserAttachmentsAllowed));
        }
    } catch (error) {
        dispatch(clearAttachmentsAllowedAction());
    }
};

export const isAttachmentsAllowedWithReasonThunkAction = ({requestTypeId, reasonTypeId}) => async (dispatch) => {
    try {
        const response = await $api(`v1/requests/types/${requestTypeId}/reasons/${reasonTypeId}/attachments-allowed`);
        console.log("REASON: ",response.data);
        if (response.status === 200) {
            dispatch(isAttachmentsAllowedAction(response.data.isUserAttachmentsAllowed));
            return response.data.isUserAttachmentsAllowed;
        }
    } catch (error) {
        dispatch(clearAttachmentsAllowedAction());
        return null;
    }
};
